<span [class]="class" [ngStyle]="{'cursor':cursor, 'width': width}">
    <ng-content></ng-content>
</span>